module.exports = __webpack_public_path__ + "img/Frame 5139.c2611c55.jpg";